import {
  ClassroomCreateInput,
  Organization,
  UserEnrollmentInput,
  UserRole,
  StudentCreateInput
} from 'types/schema-generated-types';
import maybeGetExternalId from 'utilities/external-id-util';
import { CreateClassroomForm, StudentFormEntry } from '../types';
import isValidStudent from './is-valid-student';

const buildClassCreateInput = (
  values: CreateClassroomForm,
  organizations: Organization[]
): ClassroomCreateInput => {
  const { CREATE_CLASS, ADD_STUDENTS } = values;

  const students = ADD_STUDENTS.students
    .filter(isValidStudent)
    // Omit the placeholder 'id' from the form entry when persisting...
    .map(({ secretCode, id, ...student }: StudentFormEntry) => ({
      ...student,
      organizationId: +CREATE_CLASS.organization,
      ...(secretCode
        ? { loginType: secretCode.loginType, password: secretCode.code }
        : { loginType: CREATE_CLASS.secretCodeType, password: '' }),
      licenses: student.licenses?.map(x => ({ productCurriculumId: x.productCurriculumId })),
      group: student.group && [student.group],
      ...maybeGetExternalId({
        candidateSourceId: student.email as string,
        entities: organizations.map(({ externalId }) => ({ externalId }))
      })
    })) as StudentCreateInput[];

  const educatorEnrollment: UserEnrollmentInput = {
    userId: +CREATE_CLASS.educator,
    classroomRole: [UserRole.EDUCATOR]
  };

  const coeducatorEnrollments: UserEnrollmentInput[] =
    CREATE_CLASS.coeducators?.map(({ id }) => ({
      userId: +id,
      classroomRole: [UserRole.COEDUCATOR]
    })) ?? [];

  const data = {
    name: CREATE_CLASS.name,
    organizationId: +CREATE_CLASS.organization,
    academicSessionId: +CREATE_CLASS.schoolYear,
    loginType: CREATE_CLASS.secretCodeType,
    color: CREATE_CLASS.color,
    userEnrollments: [educatorEnrollment, ...coeducatorEnrollments]
  };

  return { ...data, ...(students.length > 0 && { students }) };
};

export default buildClassCreateInput;
